import { render, staticRenderFns } from "./test-messenger-layout.vue?vue&type=template&id=2b0e262a&scoped=true&"
import script from "./test-messenger-layout.vue?vue&type=script&lang=js&"
export * from "./test-messenger-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e262a",
  null
  
)

export default component.exports